import React from 'react';

const HomeThirdPart = () => {
    return (
        <div className="container mb-5">
            <div className="row">
            <div className="col-md-8">
                <h1>Libero volutpat pulvinar</h1>
                <p className="text-uppercase font-weight-bold">Gravida sed consequat lorem ipsum dolor</p>
                <img src="https://i.ibb.co/fYStrVw/new.png" alt="new" width="100%" className="pr-4 mb-2"></img>
                <p className="pr-5 mt-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                <a className="custom-btn text-dark text-uppercase font-weight-bold mt-3" href="/">More info</a>
            </div>
            <div className="col-md-4">
                <h1 className="mb-4 mt-2 ">Categories</h1>
                <p className="font-weight-bold text-secondary">Ipsum ante vivamus semper faucibus varius. Nam risus nibh, commondo vulputate.</p>
                <p className="text-secondary">8 hours ago</p>
                <hr/>
                <p className="font-weight-bold text-secondary">Ipsum ante vivamus semper faucibus varius. Nam risus nibh, commondo vulputate.</p>
                <p className="text-secondary">1 day ago</p>
                <hr/>
                <p className="font-weight-bold text-secondary">Ipsum ante vivamus semper faucibus varius. Nam risus nibh, commondo vulputate.</p>
                <p className="text-secondary">4 days ago</p>
                <a className="custom-btn text-dark text-uppercase font-weight-bold" href="/">More info</a>
                
                </div>
            </div>
        </div>
    );
};

export default HomeThirdPart;